import { useMemo } from "react";
import { useQuery, useQueryClient, useMutation } from "react-query";
import { TOOL_TYPE } from "shared/enums";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";

export function useBSMs() {
  const queryClient = useQueryClient();
  const { isLoading, isError, data, error } = useQuery("/prospects/bsm");

  const audios = useMemo(
    () => (data ? data.filter((d) => d.handoutType === TOOL_TYPE.Audio) : null),
    [data]
  );

  const books = useMemo(
    () => (data ? data.filter((d) => d.handoutType === TOOL_TYPE.Book) : null),
    [data]
  );

  const returnBSMMutation = useMutation(
    ({ contactId, handoutId }) =>
      makeAuthedRequest(`/prospects/handout/${contactId}/${handoutId}/false`, {
        method: "delete",
      }),
    {
      onSettled: (data, error, vars) => {
        queryClient.invalidateQueries(`/contacts/${vars.contactId}`);
        queryClient.invalidateQueries("/prospects/bsm");
      },
    }
  );

  return {
    isLoading,
    isError,
    data,
    error,

    audios,
    books,

    returnBSMMutation,
  };
}
